import axios from "./api"

export default {
  getAllProducts() {
    return axios.get(`/api/product`).then(res => res.data);
  },
  getProductsById(id) {
    return axios.get(`/api/product/${id}`).then(res => res.data);
  },
  createProduct(product) {
    return axios.post(`/api/product`, product).then(res => res.data);
  },
  updateProduct(id, product) {
    return axios.put(`/api/product/${id}`, product).then(res => res.data);
  },
  removeProduct(id) {
    return axios.delete(`/api/product/${id}`).then(res => res.data);
  },
  getNames(){
    return axios.get('/api/products/names').then(res => res.data);
  }
}